import { Box, Button, Card, Grid, IconButton, InputAdornment, Modal, TextField, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { DataGrid } from '@mui/x-data-grid';
import { RestartAlt, Search } from '@mui/icons-material';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { Controller, set, useForm } from 'react-hook-form';
import { formatDateTime } from '../../../utils/dateUtils';
import { PermissionGuard } from '../../../components/PermissionGuard';
import MultiColumnFilter from '../../../components/Filter/MultiColumnFilter';
import Loading from '../../../components/Loader/Loading';
import { NotificationLogServices } from './NotificationLogServices';
import { isMobile } from 'react-device-detect';
import StatusLog from './StatusLog';

const WhatsappMessageList = () => {
  const navigate = useNavigate();
  // State to store the total row count inititally before server respond
  const [rowCount, setRowCount] = useState(5);

  // State to store the row count used by the DataGrid
  const [rowCountState, setRowCountState] = useState(rowCount);

  // Update rowCountState whenever rowCount changes
  useEffect(() => {
    setRowCountState((prevRowCountState) =>
      rowCount !== undefined ? rowCount : prevRowCountState,
    );
  }, [rowCount, setRowCountState]);

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 50,
    filters: {
      searchKey: "",
      sortKey: 'updatedAt',
      sortDirection: 'desc',
      filterOptions: []
    }
  });

  const handlePaginationModel = (newPagination) => {
    setPaginationModel({
      ...paginationModel,
      page: newPagination.page,
      pageSize: newPagination.pageSize
    });
  }
  /******************* Sorting model  ******************************/
  const [sortModel, setSortModel] = useState([
    {
      field: paginationModel.filters.sortKey,
      sort: paginationModel.filters.sortDirection,
    },
  ]);

  const handleSortingChange = (newSortModel) => {
    console.log("new sort model", newSortModel);
    if (newSortModel && newSortModel.length > 0) {
      setSortModel(newSortModel);
      setPaginationModel(prev => ({
        ...prev,
        filters: {
          ...prev.filters,
          sortKey: newSortModel[0].field,
          sortDirection: newSortModel[0].sort
        }
      }));
    }
  }

  const [showStatusHistory, setShowStatusHistory] = useState({
    open: false,
    statusHistory: []
  });
  
  const columns = [
    { field: 'to', headerName: 'Recipient', flex: 1 ,sortable:'false',headerAlign:'center',
      renderCell: (params) => (
        <Typography variant="body2" sx={{width:'100%',textAlign:'center',fontSize:'0.6rem',color:'#000000de'}}>{params.row.to}</Typography>
      )
    },
    
    
    {
      field:'details',headerName: `Stats`,flex:2,headerAlign:'center',sortable:false,
      renderCell: (params) => (
        <Box sx={{display:'flex',flexDirection:'column',gap:1,p:1,width:'100%'}}>
          <Box sx={{display:'flex'}}>
            <Typography sx={{fontSize:'0.5rem',width:'25%'}}>Type</Typography>
            <Typography sx={{fontSize:'0.5rem',width:'2%',mx:1}}>:</Typography>
            <Typography sx={{fontSize:'0.5rem'}}>{params.row.type}</Typography>
          </Box>
          {params.row.template?.name &&<Box sx={{display:'flex'}}>
            <Typography sx={{fontSize:'0.5rem',width:'25%'}}>Template</Typography>
            <Typography sx={{fontSize:'0.5rem',width:'2%',mx:1}}>:</Typography>
            {/* booking_confirmation_customer */}
            {/* remove underscaore from name with space and capitalize */}
            <Typography sx={{fontSize:'0.5rem'}}>{(params.row.template.name)}</Typography>
          </Box>}
        </Box>
      ),
    },
    {
      field: 'createdAt',headerName: 'Sent On',flex:1,headerAlign:'center',
      renderCell: (params) => (
        <Typography variant="body2" sx={{width:'100%',textAlign:'center',fontSize:'0.6rem',color:'#000000de'}}>
          {params.row.statusHistory && params.row.statusHistory.length > 0
            ? formatDateTime(params.row.statusHistory[0].timestamp)
            : params.row.createdAt
              ? formatDateTime(params.row.createdAt)
              : 'N/A'}
        </Typography>
      ),
    },
    {
      field: 'status',headerName: 'Status',flex:1,headerAlign:'center',
      renderCell: (params) => (
        <Typography variant="body2" sx={{width:'100%',textAlign:'center',fontSize:'0.6rem',color:'#000000de'}}>
          {params.row.status}
          {params.row.statusHistory && params.row.statusHistory.length > 0 && <Tooltip title="View Status History">
            <Typography
                onClick={() => setShowStatusHistory({ open: true, statusHistory: params.row.statusHistory })}
                sx={{
                    fontSize: '0.7rem',
                    color: 'primary.main',
                    fontWeight: 500,
                    // textDecoration: 'underline',
                    cursor: 'pointer',
                    '&:hover': {
                        color: 'primary.dark'
                    }
                }}
            >
                View logs
            </Typography>
          </Tooltip>}
        </Typography>
      ),
    }
  ]
  const [notifications, setNotifications] = useState([]);
  const [isLoading, setIsloading] = useState(false);
  const fetchNotificationList = async () => {
    setIsloading(true);
    try {
      const notificationResponse = await NotificationLogServices.fetchNotificationLog({
        page: paginationModel.page,
        limit: paginationModel.pageSize,
        filters: {
          searchKey: paginationModel.filters.searchKey,
          sortKey: paginationModel.filters.sortKey,
          sortDirection: paginationModel.filters.sortDirection,
          filterOptions: paginationModel.filters.filterOptions || []
        }
      });
      if (notificationResponse.success == '1') {
        setNotifications(notificationResponse.data.list);
        setRowCount(notificationResponse.data.pagination.totalCount);
      } else if (notificationResponse.success == '0') {
        console.log("Error fetching Notifications:", notificationResponse.message);
      }
    } catch (error) {
      console.log("Error fetching Notifications:", error)
    } finally { setIsloading(false); }
  }
  useEffect(() => {
    fetchNotificationList();
  }, [paginationModel])

  const filterableColumns = [
    {
      key: 'title',
      label: 'Notification title',
      type: 'text'
    },
    {
      key: 'audienceType',
      label: 'Audeience Type',
      type: 'select',
      options: [
        { value: 'customer', label: 'Customer' },
        { value: 'expert', label: 'Service Expert' },
      ]
    },
    {
      key: 'status',
      label: 'Status',
      type: 'select',
      options: [
        { value: 'PENDING', label: 'Pending' },
        { value: 'QUEUED', label: 'Queued' },
        { value: 'PROCESSING', label: 'Processing' },
        { value: 'COMPLETED', label: 'Completed' },
        { value: 'FAILED', label: 'Failed' },
        { value: 'CANCELLED', label: 'Cancelled' },
        { value: 'PROCESSED', label: 'Processed' },
      ]
    },
    {
      key: 'isActive',
      label: 'Account',
      type: 'select',
      options: [
        { value: 'true', label: 'Active' },
        { value: 'false', label: 'Inactive' }
      ]
    },
    {
      key: 'isVerified',
      label: 'Is Verified',
      type: 'select',
      options: [
        { value: 'true', label: 'Verified' },
        { value: 'false', label: 'Not Verified' }
      ]
    },
    {
      key: 'scheduledDateTime',
      label: 'Scheduled Date',
      type: 'date'
    },
    {
      key: 'updatedAt',
      label: 'Sent Date',
      type: 'date'
    },
    // {
    //   key: 'isTester',
    //   label: 'Is Tester',
    //   type: 'select',
    //   options: [
    //     { value: 'true', label: 'True' },
    //     { value: 'false', label: 'False' }
    //   ]
    // }
  ];
  const handleApplyFilter = (filterData) => {
    // Process filter data
    console.log(filterData);
    setPaginationModel({
      ...paginationModel,
      page: 0, // Reset to first page when applying new filters
      filters: {
        ...paginationModel.filters,
        // Convert MultiColumnFilter options to a format your backend can understand
      filterOptions: filterData.filterOption.filter(filter => filter.fieldName && filter.value) // Remove empty filters
      }
    });
  }

  const { control, handleSubmit,getValues, reset } = useForm();
  /**** Advanced multi column filter related ****/
  const [clearMultiFilter, setClearMultiFilter] = useState(false);
  const clearFilters = () => {
      reset({
        searchKey: "",
      });
      setPaginationModel({
        ...paginationModel,
        filters: {
          ...paginationModel.filters,
          searchKey: "",
          sortBy: 'createdAt',
          sortType: 'desc',
          filterOptions: []
        }
      });
  
      // Trigger clear for MultiColumnFilter
      setClearMultiFilter(true);
  
      // Reset the clear trigger after a short delay
      setTimeout(() => setClearMultiFilter(false), 100);
  }
  function onSubmit(data) {
    const filtersData = getValues();
    setPaginationModel({
      ...paginationModel,
      filters: {
        ...paginationModel.filters,
        searchKey: filtersData.searchKey,
      }
    });
  }
  return (
    <Box>
      {/* <Box sx={{ p: '.5% 1%', border: '2px solid lightGray', bgcolor: 'lightGray' }}>
        <Typography sx={{ fontWeight: 600, fontSize: '0.85rem' }} >Sent Notifications</Typography>
      </Box> */}
      <Card>
        <Box sx={{ overflow: "auto" }}>
          <Box
            sx={{
              width: "100%", display: "table", tableLayout: "fixed",
              backgroundColor: "#fff", borderRadius: '.5rem',
              '& .odd': {
                bgcolor: 'white',
              },
              '& .even': {
                bgcolor: '#ECECEC',
              },
            }}>

            {isLoading && <Loading />}
            <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center', px: '1%' }}>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <MultiColumnFilter
                  filterableColumns={filterableColumns}
                  onApplyFilter={handleApplyFilter}
                  externalClear={clearMultiFilter}
                  defaultFilterOptions={paginationModel.filters.filterOptions}
                />
                {/* <ExportAll paginationModel={paginationModel} columns={columns} statusOptions={statusOptions} /> */}
              </Box>
              <Box sx={{display:{xs:'none',sm:'block'}}}>
                {/* <QuickSearchTool filterModel={filterModel} setFilterModel={setFilterModel} /> */}
                <Grid container spacing={1} sx={{ p: '1%' }} component={'form'} onSubmit={handleSubmit(onSubmit)}>
                    <Grid item xs={9} lg={8}>
                      <Controller
                        name="searchKey"
                        control={control}
                        // defaultValue=""
                        render={({ field }) => (
                            <TextField
                            {...field}
                            placeholder="Search here....."
                            // label="Search"
                            size="small"
                            fullWidth
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                paddingLeft: '0px',
                                }
                            }}
                            InputProps={{  // Changed from slotProps to InputProps
                                inputProps: {
                                style: {
                                    height: '0.6rem',
                                    // textTransform: 'uppercase',
                                    fontSize: 'x-small'
                                },
                                },
                                startAdornment: (
                                <InputAdornment position="start">
                                    <IconButton>
                                    <Search sx={{ fontSize: 'x-small' }} />
                                    </IconButton>
                                </InputAdornment>
                                ),
                            }}
                            />
                        )}
                        />
                    </Grid>
                    <Grid item xs={3} sm={4} >
                        <Tooltip title="Search" sx={{ ml: 1, p: 0 }}>
                        <IconButton
                            size='small'
                            color="primary"
                            type="submit"
                            sx={{ border: "1px solid", borderRadius: "7px", padding: "1%", ml: 1 }}
                        >
                            <Search sx={{ fontSize: '.85rem' }} />
                        </IconButton>
                        </Tooltip>
                        <Tooltip title="Clear All Filters">
                        <IconButton
                            size='small'
                            color="primary"
                            sx={{ marginLeft: "10px", border: "1px solid", color: "#f00", borderRadius: "7px", padding: "1%" }}
                            onClick={clearFilters}
                        >
                            <RestartAlt sx={{ fontSize: '.85rem' }} />
                        </IconButton>
                        </Tooltip>
                    </Grid>
                </Grid>
              </Box>
              {/* <Box>
                <TextField
                  value={quickFilterText}
                  onChange={(event) => setQuickFilterText(event.target.value)}
                  placeholder="Quick Search ..."
                  size="small"
                  fullWidth
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      paddingLeft: '0px',
                    }
                  }}
                  InputProps={{
                    inputProps: {
                      style: {
                        height: '0.6rem',
                        textTransform: 'uppercase',
                        fontSize: 'x-small'
                      },
                    },
                    startAdornment: (
                      <InputAdornment position="start">
                        <IconButton>
                          <Search sx={{ fontSize: 'x-small' }} />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Box> */}
            </Box>
            <DataGrid
              rows={notifications}
              columns={columns.map((col) => ({
                ...col,
                flex: col.flex || 1, // Ensure columns resize dynamically
                minWidth: col.minWidth || 150, // Set a minimum width to avoid overlap
              }))}
              getRowId={(row) => row._id}
              rowCount={rowCount}
              pageSizeOptions={[5, 10, 20, 50, 100]}
              paginationModel={paginationModel}
              paginationMode="server"
              onPaginationModelChange={handlePaginationModel}

              // Add these props for page numbers
              showFirstButton={true}
              showLastButton={true}

              // filterModel={filterModel}
              sortingMode="server"
              sortModel={sortModel}
              onSortModelChange={handleSortingChange}
              disableMultiSort={true}

              loading={isLoading}
              getRowClassName={(params) => {
                // console.log("checking customer is deleted",params.row.customer?.deletedAt)
                // Check if customer is deleted
                if (params.row.customer?.deletedAt) {
                  return 'deleted-row';
                }
                // Keep alternating row colors for non-deleted rows
                return params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
              }}

              disableColumnMenu
              disableRowSelectionOnClick
              // disableColumnFilter
              // disableColumnSelector
              disableDensitySelector
              sortingOrder={['asc', 'desc']}
              slots={{
                // toolbar: GridToolbar,
                loadingOverlay: Loading,
                // Optionally use custom pagination
                // pagination: CustomPagination,
              }}
              // slotProps={{
              //   toolbar: {
              //     showQuickFilter: true,  
              //   },
              // }}
              autoHeight
              getRowHeight={() => 'auto'}
              sx={{
                '& .MuiDataGrid-cell': {
                border: 1,
                borderRight: 0,
                borderTop: 0,
                borderColor: 'lightgrey',
                display: 'flex',
                alignItems: 'center',
                // justifyContent: 'center',
                },
                '& .MuiDataGrid-columnHeaders': {
                  borderBottom: '2px solid rgba(224, 224, 224, 1)',
                  borderTop: '2px solid rgba(224, 224, 224, 1)',
                  fontWeight: 600,
                  fontSize: '0.75rem',
                  p:0,
                  height: 'fit-content',
                  minHeight:'0 !important',
                  height:'2rem'
                },
                '& .MuiDataGrid-columnHeader': {
                borderLeft: '1px solid rgba(224, 224, 224, 1)',
                '&:last-child': {
                    borderRight: 'none',
                },
                },
                '& .MuiDataGrid-columnHeaderTitle': {
                fontWeight: 600,
                color: '#3e3e3e'
                },
                '& .MuiDataGrid-row': {
                '&:last-child .MuiDataGrid-cell': {
                    borderBottom: '1px solid rgba(224, 224, 224, 1)',
                },
                '& .MuiDataGrid-cell:last-child': {
                    borderRight: 'none',
                },
                },
                '& .MuiDataGrid-columnSeparator': {
                display: 'none',
                },
            }}
            />
          </Box>
        </Box>
      </Card>
      <Modal
          open={showStatusHistory.open}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{ overflow: "scroll" }}
      >
          <Box 
              sx={{
                  position: 'absolute',
                  top: (isMobile) ? '80%' : '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  bgcolor: 'background.paper',
                  border: '2px solid #ddd',
                  boxShadow: 24,
                  width: {xs: "95%" ,sm:'75%',md: "50%"},
                  maxHeight: "90vh", // Max height for the modal
                  overflowY: "auto", // Enable scrolling within the modal
                  // display: "flex",
                  // flexDirection: "column",
              }}
          >
              <StatusLog statusHistory={showStatusHistory.statusHistory} onClose={()=>setShowStatusHistory({open:false,statusHistory:[]})} />
          </Box>
      </Modal>
    </Box>
  )
}

export default WhatsappMessageList